import PatcraftApi from "../../../scripts/patcraft-api";

// Initial state
const state = () => ({
  pageNumber: 1,
  pageSize: 16,
  totalPages: 0,
  isFetching: false,
  trimsAndAccessories: []
});

// Getters
const getters = {
  trimsAndAccessories: (state, getters, rootState) => {
    return state.trimsAndAccessories;
  },
  pageNumber: (state, getters, rootState) => {
    return state.pageNumber;
  },

  pageSize: (state, getters, rootState) => {
    return state.pageSize;
  },
  isFetching: state => {
    return state.isFetching;
  },
  showLoadMore: state => {
    return (
      state.totalPages > state.pageNumber ||
      (state.isFetching && state.trimsAndAccessories.length === 0)
    );
  }
};

// Actions
const actions = {
  async fetchTrimsAndAccessories({ commit, state, dispatch }, data) {
    if (state.isFetching) {
      return;
    }
    dispatch("setIsFetching", true);
    if (state.pageNumber === 1) {
      dispatch("setResults", []);
      PatcraftApi.getProductFiltersTnA({
        filter: { ...data.filter, PageSize: 0 }
      })
        .then(res => {
          dispatch(
            "filters/updateFilterOptions",
            { filters: [...res.data] },
            { root: true }
          );
        })
        .catch(err => {
          console.log(err);
        });
    }

    try {
      const response = await PatcraftApi.getAllTrimAndAccessoryData(data);
      commit("setResults", { results: [...response.data.items] });
      commit("setTotalPages", { pages: response.data.totalPages });
      dispatch("setIsFetching", false);
    } catch (error) {
      console.error(error);
      dispatch("setIsFetching", false);
    }
  },
  setPageNumber({ commit }, page) {
    commit("setPageNumber", { page });
  },
  setResults({ commit }, results) {
    commit("setResults", { results });
  },
  setIsFetching({ commit }, value) {
    commit("setIsFetching", { value });
  }
};

// Mutations
const mutations = {
  setPageNumber(state, { page }) {
    state.pageNumber = page;
  },
  setResults(state, { results }) {
    if (state.pageNumber > 1 && results.length > 0) {
      state.trimsAndAccessories = [...state.trimsAndAccessories, ...results];
    } else {
      state.trimsAndAccessories = [...results];
    }
  },

  setIsFetching(state, { value }) {
    state.isFetching = value;
  },
  setTotalPages(state, { pages }) {
    state.totalPages = pages;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
